import React from "react";
import { Link } from "react-router-dom";

const TermsConditions = () => {
  return (
    <div className="px-6 py-12 max-w-4xl mx-auto mt-10 lg:mt-20 shadow-lg rounded-lg">
      <h1 className="text-4xl font-bold mb-6 border-b pb-3">
        Terms & Conditions
      </h1>
      <p className="mb-4 leading-relaxed">
        Welcome to <span className="font-semibold">awcgarejelebi.com</span>. By
        using our services, you agree to the following terms and conditions.
        Please read them carefully.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Account Registration
      </h2>
      <ul className="list-disc pl-8 space-y-2">
        <li>
          You must provide a valid email address nad create a secure passwor when registering.
        </li>
        <li>
          You are responsible for maintaining the confidentiality of your
          account credentials.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Acceptable Use
      </h2>
      <ul className="list-disc pl-8 space-y-2">
        <li>
          You agree not to use our services for illegal or unauthorized
          purposes.
        </li>
        <li>You must not share your account with others.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Privacy
      </h2>
      <p className="leading-relaxed">
        We collect and use your information in accordance with our{" "}
        <Link
          to="/privacy-policy"
          className="text-baseGreen underline hover:text-darkGreen"
        >
          Privacy Policy
        </Link>
        .
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Termination
      </h2>
      <p className="leading-relaxed">
        We reserve the right to suspend or terminate your account if you violate
        these terms.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Governing Law
      </h2>
      <p className="leading-relaxed">
        These terms are governed by the laws of Georgia and the General Data
        Protection Regulation, and any disputes will be resolved in Georgian
        courts.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Contact Us
      </h2>
      <p className="leading-relaxed">
        If you have any questions about these Terms & Conditions, please contact
        us at <span className="text-baseGreen">awcgarejelebi@gmail.com</span>
      </p>
    </div>
  );
};

export default TermsConditions;
